<template>
  <div v-if="splitInvoiceIds.length" class="invoice-tags">
    <span class="invoice-tags__title">
      {{ uploaded ? "Uploaded" : "Searched" }} invoices:
    </span>
    <div v-if="splitInvoiceIds.length" class="invoice-tags__items">
      <div
        v-for="(invoiceId, index) in splitInvoiceIds"
        :key="index"
        class="invoice-tags__items__item"
        @click="onRemove(invoiceId)">
        <div v-tooltip="invoiceId" v-html="invoiceId"></div>
        <div class="invoice-tags__items__item__close-icon">
          <span class="mi-20px mi-times" aria-hidden="true"></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "InvoiceTags",
  props: {
    splitInvoiceIds: { type: Array, default: () => [] },
    uploaded: { type: Boolean, default: false },
  },
  methods: {
    onRemove(invoiceId) {
      this.$emit("onRemove", invoiceId);
    },
  },
};
</script>
<style lang="scss" scoped>
.invoice-tags {
  display: flex;
  &__title {
    margin-right: 8px;
    margin-top: 12px;
    font-family: "Maersk Text";
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: var(--Gray-600);
    white-space: nowrap;
  }
  &__items {
    display: flex;
    margin: 8px 0;
    flex-wrap: wrap;
    align-items: center;
    &__item {
      cursor: pointer;
      display: flex;
      align-items: center;
      background: #ededed;
      border-color: transparent;
      color: var(--Gray-900);
      text-decoration: none;
      position: relative;
      vertical-align: middle;
      border-radius: 20px;
      padding: 4px 12px 6px 12px;
      margin-right: 4px;
      margin-bottom: 4px;
      border: 0 solid transparent;
      &__close-icon {
        cursor: pointer;
        display: flex;
        fill: var(--icon-bg);
        stroke: var(--icon-bg);
      }
    }
  }
}
</style>
